import { InjectionToken } from "@angular/core";
import { PictureAutomobilePlatformApiService } from "../picture-automobile-platform-api.service";

export const HTTP_PICTURE_AUTOMOBILE_PLATFORM_SERVICE = new InjectionToken(
  'PictureAutomobilePlatformApiService'
);

export const PICTURE_AUTOMOBILE_PLATFORM_API_PROVIDER = {
  provide: HTTP_PICTURE_AUTOMOBILE_PLATFORM_SERVICE,
  useClass: PictureAutomobilePlatformApiService,
};